import React, { useContext, useEffect } from "react";
import Context from "../../../../context/Context";
import { Block, BlockOutlined, Warning, Info, LocalFireDepartment, Replay, Layers, LayersClear } from '@mui/icons-material';
import Pendency from "../../../dashboard/ficha/Pendency";
import { Modal } from "react-bootstrap";
import language from '../../../../nls/language.json';
import { DateTimeFmt } from "../../../../utils/DataUtils";
import { statusColor } from "../../../../utils/statusColor";
import "./styles.css"

export const WagonTableBody = ({
  data,
  isEdit,
  handleAddPeca,
  reset
}) => {
  const {
    setCode,
    selectedFurnace,
    postWagon,
    wagon,
    confirmedWagon,
    getConfirmedWagon,
    selectedWagon,
    toolTipText,
    setToolTipText,
    showModalFicha,
    setShowModalFicha,
    selectedCountry,
    getPartsByFurnace
  } = useContext(Context);

  const dataFiltered = data.filter((item) => item.wagonIsTrue === false);

  useEffect(() => {
    setCode("");
  }, []);

  const modal = () => {
    return (
      <Modal show={showModalFicha} onHide={() => {
        setToolTipText("Vazio");
        setShowModalFicha(false);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.modal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{toolTipText}</p>
        </Modal.Body>
      </Modal>
    );
  };


  console.log(data);
  

  const AddPendency = (data) => {
    setToolTipText((
      <Pendency
        data={data}
        setIdScreenFicha={() => {
          getPartsByFurnace(selectedFurnace)
          getConfirmedWagon()
          reset()
        }}
      />
    ));
    setShowModalFicha(true);
  }

  const btnAddPendency = (item, statusWagon) => {
    return item.pend_Key && (item.ordem_SetAtual === item.pendMotOrigem_SAPSector) || statusWagon ? <BlockOutlined /> : (
      <Warning
        className="btn-add-pendency-wagon"
        onClick={() => AddPendency({
          ordem: item.ordem_Serial,
          ordem_SetAtual: item.ordem_SetAtual
        })}
      />
    )
  }



  const pendencyStatus = (item) => {

    return item.pend_Key && item.ordem_SetAtual === item.pendMotOrigem_SAPSector ? (
      <span data-tooltip={`
          ${item.pend_Status}
          - ${item.pendMot_Descricao} ${item.pend_DataPrevisao && item.pend_Status !== "FINALIZADO"
          ? "- PREVISÃO: " + DateTimeFmt(item.pend_DataPrevisao)
          : item.pend_Status === "ABERTO"
            ? "- PREVISÃO: Não lançado"
            : ""}`}
      >
        <Info color={statusColor(item)} />
      </span>) : <></>
  }

  const moldIsTrueStatus = (status, statusMolde) => {
    if (status == true) return ""
    else if (status == false) {
      const tooltip = statusMolde ?? "Molde Indisponível";
      return <span data-tooltip={tooltip}> <Block /> </span>
    }

  }

  const wagonStatus = (status) => {
    return status
      ? <span data-tooltip={"Peça no Vagão"}> <LocalFireDepartment className="icon-car-wagon" /> </span>
      : <></>
  }

  const tableBody = (key, item, status, statusWagon, moldStatus, isReprocesso, hasBase) => {
    const BOMBA_A = !item.bomba_A ? "" : `A ${parseInt(item.bomba_A)}`;
    const BOMBA_B = !item.bomba_B ? "" : `B ${parseInt(item.bomba_B)}`
    const BOMBA_C = !item.bomba_C ? "" : `C ${parseInt(item.bomba_C)}`

    const TOL_A_MIN = !item.tol_A_Min ? "" : `-${item.tol_A_Min}`
    const TOL_A_MAX = !item.tol_A_Max ? "" : `+${item.tol_A_Max}`

    const TOL_B_MIN = !item.tol_B_Min ? "" : `-${item.tol_B_Min}`
    const TOL_B_MAX = !item.tol_B_Max ? "" : `+${item.tol_B_Max}`

    const TOL_C_MIN = !item.tol_C_Min ? "" : `-${item.tol_C_Min}`
    const TOL_C_MAX = !item.tol_C_Max ? "" : `+${item.tol_C_Max}`

    const copyToClipboard = (text) => {
      navigator.clipboard.writeText(text).then(() => {
        alert('Copiado para a área de transferência');
      }).catch(err => {
        console.error('Erro ao copiar: ', err);
      });
    };

    const jsonItens = {
      hp: item.hp,
      moldIsTrue: moldIsTrueStatus(status, moldStatus),
      pieceIsTrue: pendencyStatus(item),
      reprocesso: isReprocesso ? <span data-tooltip="Reprocesso"><Replay /></span> : "",
      hasBase: hasBase
        ? <span data-tooltip="Com Base" style={{ color: "green" }}><Layers /></span>
        : <span data-tooltip="Sem Base" style={{ color: "red" }}><LayersClear /></span>,
      ordem_Serial: (
        <span onClick={() => copyToClipboard(item.ordem_Serial)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
          {item.ordem_Serial}
        </span>
      ),
      ordem_Part_Cod: `${item.ordem_Part_Cod} - ${item.ordem_Part_Short}`,
      bomba_A: item.molde_Descricao.includes('RAIO') ? 'MOLDE RAIO' : `${BOMBA_A} ${TOL_A_MIN} ${TOL_A_MAX} / ${BOMBA_B} ${TOL_B_MIN} ${TOL_B_MAX} / ${BOMBA_C} ${TOL_C_MIN} ${TOL_C_MAX}`,
      subProduto_Desc: item.subProduto_Desc,
      ordem_VehCod: `${item.ordem_VehDesc}`,
      btn_edit: btnAddPendency(item, statusWagon),
    };

    return jsonItens[key];
  };

  function getBackgroundColor(cor_HP) {
    return cor_HP;
  };

  const itensParts = [
    'hp',
    'moldIsTrue',
    'Mold',
    'pieceIsTrue',
    'reprocesso',
    'hasBase',
    // 'wagonIsTrue',
    'ordem_Serial',
    'ordem_Part_Cod',
    'bomba_A',
    'subProduto_Desc',
    'ordem_VehCod',
    'btn_edit'
  ];

  const handleSelecterd = (part) => {
    return selectedWagon?.wagon && Array.isArray(selectedWagon.wagon)
      && selectedWagon.wagon.some((peca) =>
        peca.ordem_Serial === part.ordem_Serial
      );
  }

  return (
    <>
      {dataFiltered.map((part, index) => (
        <tr
          className={`${handleSelecterd(part.pecasSetor) ? "activeSelectedItem" : ""} `}
          key={index}>
          {itensParts.map((item, subIndex) => (
            <td
              style={{ backgroundColor: item === "hp" ? getBackgroundColor(part.pecasSetor.cor_HP) : "", color: item === "hp" ? "white" : "" }}

              onClick={!isEdit.isEdit ? () => { } :
                () => handleAddPeca(selectedWagon.wagonInfo?.vagao_Key ? confirmedWagon : wagon, part.pecasSetor, part.moldIsTrue, part.wagonIsTrue)}

              className={`${item === 'moldIsTrue' || item === 'pieceIsTrue' || item === 'reprocesso' || item === 'wagonIsTrue' ? 'td-icons' : ""}
              ${item === "ordem_Serial" ? "corOrdemSerial" : ""} p-1`}
              key={subIndex}
            >
              {tableBody(item, part.pecasSetor, part.moldIsTrue, part.wagonIsTrue, part.moldStatus, part.isReprocesso, part.hasBase)}
            </td>
          ))}
        </tr>
      ))}
      {modal()}
    </>
  )
}